import React, { Suspense, useEffect } from "react";
import { HashRouter, Route, Routes, useNavigate } from "react-router-dom";

import { CSpinner, useColorModes } from "@coreui/react";
import "./scss/style.scss";
import "./layout/main/style/form/Form.css";
import "./layout/main/style/button/button.css";
import "./layout/main/style/modal/modal.css";
import "./layout/main/style/table/table.css";

// We use those styles to show code examples, you should remove them in your application.
import "./scss/examples.scss";
import { useDispatch, useSelector } from "react-redux";
import { AuthLogOut, GETAuthLogin } from "./features/auth/Slice";

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./components/login/Login"));
// const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./components/page404/Page404"));
const Page500 = React.lazy(() => import("./components/page500/Page500"));

const App = () => {
  const { isColorModeSet, setColorMode } = useColorModes(
    "coreui-free-react-admin-template-theme",
  );
  const settings = useSelector((state) => state.settings);

  useEffect(() => {
  const theme = settings?.theme || "light"; // force light fallback

  setColorMode(theme);
}, [settings?.theme]);


  // useEffect(() => {
  //   if (settings?.theme) {
  //     setColorMode(settings?.theme);
  //   }

  //   if (isColorModeSet()) {
  //     return;
  //   }

  //   setColorMode(settings.theme);
  // }, []);

  // Auth Management
  // const auth = useSelector((state) => state.auth);
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getAuth = async () => {
    try {
      const res = await dispatch(GETAuthLogin());

      if (!res.payload.success) {
        await dispatch(AuthLogOut());
        navigate("/");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAuth();
  }, []);

  // useEffect(() => {
  //   if (auth.isLogin) {
  //     navigate("/dashboard");
  //   } else {
  //     navigate("/");
  //   }
  // }, [auth]);

  return (
    // <HashRouter>
    <Suspense
      fallback={
        <div className="pt-3 text-center">
          <CSpinner color="primary" variant="grow" />
        </div>
      }>
      <Routes>
        <Route exact path="/" name="Login Page" element={<Login />} />
        {/* <Route
            exact
            path="/register"
            name="Register Page"
            element={<Register />}
          />*/}
        <Route exact path="/404" name="Page 404" element={<Page404 />} />
        <Route exact path="/500" name="Page 500" element={<Page500 />} />
        <Route path="*" name="Home" element={<DefaultLayout />} />
      </Routes>
    </Suspense>
    // </HashRouter>
  );
};

export default App;
